import useTableRequest from "../../hooks/useTableRequest";
import { useEffect, useState } from "react";
import Pagination from "../../components/common/pagination/Pagination";
import Table from "../../components/common/table/Table";
import Title from "../../components/common/title/Title";
import { learnCategoryListColumns } from "../../constant/tables-columns/tablesColums";
import { useNavigate } from "react-router";

export default function LearnCategoryList() {
  const tableRequest = useTableRequest({ initialLoading: true });
  const [categoryData, setCategoryData] = useState([]);
  const [pagination, setPagination] = useState(null);

  const getCategory = async (params) => {
    const path = "admin/learnCategories";
    return tableRequest.load({ path, params: { ...params } }, (response) => {
      setCategoryData(response?.data?.result.data);
      setPagination(response?.data?.result);
    });
  };

  useEffect(() => {
    getCategory({});
  }, []);

  const [filter, setFilter] = useState();

  const filterDataHandler = (newParams) => {
    setFilter({ ...filter, ...newParams });
    const allFilter = {
      ...filter,
      ...newParams,
    };
    console.log("filter", allFilter);
    getCategory(allFilter);
  };

  const data = [];

  categoryData?.map((item) =>
    data.push({
      ...item,
      key: item._id,
      id: item._id,
      name: item.name || "",
    })
  );

  console.log(data);

  const navigate = useNavigate();

  const editCategory = (singleCategory) => {
    navigate("/edit-learn-category", { state: singleCategory });
  };

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <Title title={"لیست دسته بندی آموزشات"} />
      <Table loading={tableRequest.loading} error={tableRequest.error} idle={tableRequest.status === "idle"} onRetry={tableRequest.retry} columns={learnCategoryListColumns} rows={data} onEdit={editCategory} />
      <Pagination
        pagination={pagination}
        filterDataHandler={filterDataHandler}
      />
    </div>
  );
}
